import AbstractController from "../../../../../ig_template/Resources/Public/Src/Js/Controller/AbstractController";
import Controller from "../../../../../ig_template/Resources/Public/Src/Js/Controller/Controller";

/**
 * Feedback Form
 *
 * @class
 */
class FeedbackForm extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();
    Controller.registerController(this);

    this.data = {
      $form: $('#ig-feedbackform form'),
      $genderSelect: $('#gender-select'),
      slideId: 0,
      $slides: $('.feedbackform-slide'),
      $questionSlides: $('.feedbackform-question, .feedbackform-recommend-slide'),
      $optinBoxes: $('.optin-box'),
      displayedOptinBoxes: 0,
      $qrcodeContainer: $('#qrcode')
    }

    $('#debugsubmit').on('click', e => {
      e.preventDefault();
      this.submit(true);
    });

    this.data.$optinBoxes.hide();
    this.data.$optinBoxes.eq(this.data.displayedOptinBoxes++).show();
    this.data.$slides.first().show();

    const $nextButtons = $('.feedbackform-nextslide');
    $nextButtons.on('click', e => {
      e.preventDefault();
      const slide = $(e.currentTarget).parents('.feedbackform-slide');
      if(!slide.data('validate') || this.validate(slide)) {
        const skip = parseInt($(e.currentTarget).data('skip'));
        this.nextSlide(isNaN(skip) ? 0 : skip);
      }
    });

    const $skipToEndButtons = $('.feedbackform-skipToEnd');
    $skipToEndButtons.on('click', e => {
      e.preventDefault();
      this.goToSlide(this.data.$slides.length - 1);
    });

    const $scoreSelectors = $('.score-selector');
    $scoreSelectors.on('click', e => {
      e.preventDefault();
      const $selectedScore = $(e.currentTarget);
      this.setSurveyScore(parseInt($selectedScore.data('question')), parseInt($selectedScore.data('score')));
    });

    const $additionalOptinButton = $('.feedbackform-additional-optin');
    $additionalOptinButton.on('click', e => {
      e.preventDefault();
      this.data.$optinBoxes.eq(this.data.displayedOptinBoxes++).show();
      if(this.data.displayedOptinBoxes === this.data.$optinBoxes.length) {
        $additionalOptinButton.hide();
      }
    });

    const $resetButton = $('.feedbackform-reset');
    $resetButton.on('click', e => this.reset());

    const $dobField = $('#survey-dob');
    $dobField.on('change', e => {
      if($dobField.val() === '') {
        $dobField.addClass('empty');
      } else {
        $dobField.removeClass('empty');
      }
    });

    const $mobileFields = $('.validate-mobile');
    $mobileFields.on('blur', e => {
      $(e.target).removeClass('error');
      $('.mobile-number-error').hide();
      let value = e.target.value.replaceAll(' ', '');
      if(value.match(/^49/)) {
        value = '+' + value;
      }
      if(value[0] !== '+') {
        value = '+49' + value;
      }
      if(value.length > 0 && (value.match(/^\+49/) && !value.match(/^\+491/) || value.length < 8 || !value.match(/\+[0-9]+/))) {
        $(e.target).addClass('error');
        $('.mobile-number-error').show();
      }
      e.target.value = value;

      const slide = $(e.target).parents('.feedbackform-slide');
      const nextButton = slide.find('.feedbackform-nextslide');
      if(slide.find('.error').length) {

        nextButton.attr('disabled', 'disabled');
      } else {
        nextButton.removeAttr('disabled');
      }
    });
  }

  nextSlide(skip = 0) {
    this.goToSlide(this.data.slideId + 1 + skip);
  }

  goToSlide(slideId) {
    const nextSlide = this.data.$slides.eq(slideId);

    if(nextSlide.data('forgender') && parseInt(this.data.$genderSelect.val()) !== nextSlide.data('forgender')) {
      return this.goToSlide(slideId+1);
    }

    this.data.$slides.hide();
    this.data.$slides.eq(slideId).show();
    this.data.slideId = slideId;

    if(this.data.$slides.eq(slideId).hasClass('feedbackform-end')) {
      this.submit();
    }
  }

  setSurveyScore(questionId, score) {
    $(`.selected-score[data-question=${questionId}]`).val(score);
    const $scoreSelectors = $(`.score-selector[data-question=${questionId}]`);
    $scoreSelectors.removeClass('active');
    $scoreSelectors.slice(0, score).addClass('active');
  }

  updateProgressMeters() {
    const questionSlides = this.data.$questionSlides.toArray().filter(slide => {
      const $slide = $(slide);
      return !$slide.data('forgender') || parseInt(this.data.$genderSelect.val()) === $slide.data('forgender');
    });

    questionSlides.forEach((slide, index) => {
      const progress = (index / questionSlides.length) * 100;
      $(slide).find('progress').attr('value', progress);
      $(slide).find('.progress-label').html(Math.round(progress) + '%');
    });
  }

  validate(slide) {
    const validation = slide.data('validate');

    if(validation === 'form') {
      this.updateProgressMeters();
      return this.data.$form[0].reportValidity();
    }
    if(validation === 'question') {
      return slide.find('input[type="hidden"]').val() !== '';
    }
    if(validation === 'newqr') {
      const uri = $($('#feedbackform-clubselector')[0].selectedOptions[0]).data('uri');
      if(uri) {
        // clear qrcodes
        this.data.$qrcodeContainer.html('');
        QrCreator.render({
          text: uri
        }, this.data.$qrcodeContainer[0]);
      }
    }
    return true;
  }

  submit(debug) {
    const formData = new FormData(this.data.$form[0]);
    formData.append('type', '5700');
    formData.append('tx_igfeedbackform_feedbackform[action]', 'submit');

    /*
    if(debug) {
      const json = '{"tx_igfeedbackform_feedbackform[__referrer][@extension]":"IgFeedbackform","tx_igfeedbackform_feedbackform[__referrer][@controller]":"Survey","tx_igfeedbackform_feedbackform[__referrer][@action]":"show","tx_igfeedbackform_feedbackform[__referrer][arguments]":"YTozOntzOjY6ImFjdGlvbiI7czo0OiJzaG93IjtzOjEwOiJjb250cm9sbGVyIjtzOjY6IlN1cnZleSI7czo2OiJzdXJ2ZXkiO3M6MToiMSI7fQ==bc2a531d89f1e31bdc57b480e7b3fa675b1414e5","tx_igfeedbackform_feedbackform[__referrer][@request]":"{\\"@extension\\":\\"IgFeedbackform\\",\\"@controller\\":\\"Survey\\",\\"@action\\":\\"show\\"}5ee74ef8a0b74593164daa17d51be0703f4edb88","tx_igfeedbackform_feedbackform[__trustedProperties]":"{\\"surveyLog\\":{\\"club\\":1,\\"salutation\\":1,\\"firstname\\":1,\\"lastname\\":1,\\"dob\\":1,\\"privacyPolicy\\":1,\\"comment\\":1},\\"answers\\":{\\"1\\":1,\\"2\\":1,\\"3\\":1,\\"4\\":1,\\"5\\":1,\\"6\\":1,\\"7\\":1,\\"8\\":1,\\"9\\":1,\\"10\\":1,\\"11\\":1,\\"12\\":1,\\"13\\":1,\\"14\\":1,\\"15\\":1},\\"optin\\":[{\\"firstname\\":1,\\"lastname\\":1,\\"mobile\\":1},{\\"firstname\\":1,\\"lastname\\":1,\\"mobile\\":1},{\\"firstname\\":1,\\"lastname\\":1,\\"mobile\\":1},{\\"firstname\\":1,\\"lastname\\":1,\\"mobile\\":1}]}33c245f85c2213e0b02ba374e66450e5d4bcae29","tx_igfeedbackform_feedbackform[surveyLog][club]":"1","tx_igfeedbackform_feedbackform[surveyLog][salutation]":"1","tx_igfeedbackform_feedbackform[surveyLog][firstname]":"Luca","tx_igfeedbackform_feedbackform[surveyLog][lastname]":"Test","tx_igfeedbackform_feedbackform[surveyLog][dob]":"1993-09-10","tx_igfeedbackform_feedbackform[surveyLog][privacyPolicy]":"1","tx_igfeedbackform_feedbackform[answers][1]":"2","tx_igfeedbackform_feedbackform[answers][2]":"3","tx_igfeedbackform_feedbackform[answers][3]":"4","tx_igfeedbackform_feedbackform[answers][4]":"3","tx_igfeedbackform_feedbackform[answers][5]":"2","tx_igfeedbackform_feedbackform[answers][6]":"4","tx_igfeedbackform_feedbackform[answers][7]":"3","tx_igfeedbackform_feedbackform[answers][8]":"2","tx_igfeedbackform_feedbackform[answers][9]":"4","tx_igfeedbackform_feedbackform[answers][10]":"","tx_igfeedbackform_feedbackform[answers][11]":"5","tx_igfeedbackform_feedbackform[answers][12]":"3","tx_igfeedbackform_feedbackform[answers][13]":"2","tx_igfeedbackform_feedbackform[answers][14]":"3","tx_igfeedbackform_feedbackform[answers][15]":"3","tx_igfeedbackform_feedbackform[optin][0][firstname]":"Luca","tx_igfeedbackform_feedbackform[optin][0][lastname]":"Hessel","tx_igfeedbackform_feedbackform[optin][0][mobile]":"+4917672432184","tx_igfeedbackform_feedbackform[optin][1][firstname]":"","tx_igfeedbackform_feedbackform[optin][1][lastname]":"","tx_igfeedbackform_feedbackform[optin][1][mobile]":"","tx_igfeedbackform_feedbackform[optin][2][firstname]":"","tx_igfeedbackform_feedbackform[optin][2][lastname]":"","tx_igfeedbackform_feedbackform[optin][2][mobile]":"","tx_igfeedbackform_feedbackform[optin][3][firstname]":"","tx_igfeedbackform_feedbackform[optin][3][lastname]":"","tx_igfeedbackform_feedbackform[optin][3][mobile]":"","tx_igfeedbackform_feedbackform[surveyLog][comment]":"asda"}'
      const data = JSON.parse(json);
      for(let i in data) {
        if(data.hasOwnProperty(i)) {
          formData.set(i, data[i]);
        }
      }
    }
     */

    $.ajax({
      url: window.location.href,
      data: formData,
      processData: false,
      contentType: false,
      type: 'POST'
    });
  }

  reset() {
    $('.selected-score').val('');
    $('.score-selector').removeClass('active');
    this.data.$form[0].reset();
    this.data.$optinBoxes.hide();
    this.data.displayedOptinBoxes = 0;
    this.data.$optinBoxes.eq(this.data.displayedOptinBoxes++).show();
    this.goToSlide(0);
  }
}

new FeedbackForm;
